import { CellState } from './game';

// The core solver is shared with the server; re-exported here so existing
// client imports (`from './solver'`) keep working.
export { solve } from '../shared/solver';

/** Converts a solution (cols[row] = col) into a CellState board for rendering. */
export function solutionToBoard(solution: number[], size: number): CellState[][] {
  const board: CellState[][] = Array.from({ length: size }, () => Array(size).fill(null));
  for (let row = 0; row < solution.length; row++) {
    board[row][solution[row]] = 'queen';
  }
  return board;
}
